/* eslint-disable @typescript-eslint/indent */
export enum Countries {
    US = 'us',
    AU = 'au'
}
